<template>
  <b-modal
    id="blog-guides"
    modal-class="tools"
    hide-header
    hide-footer
    centered
    @hide="updateGuides"
  >
    <!-- visible -->
    <template v-if="show == 'guides'">
      <div class="header__tools">
        <span class="ico" @click="$bvModal.hide('blog-guides')">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
            <path
              d="M28 18H8M8 18L16 10M8 18L16 26"
              stroke="#606770"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <h3>Guides</h3>
        <span
          class="ico ico__search"
          @click="show = 'search'"
          v-b-tooltip.hover
          title="Search Guide"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.85406 19.7087C4.39643 19.7087 0 15.3122 0 9.85437C0 4.39656 4.39643 0 9.85406 0C15.3117 0 19.7081 4.39656 19.7081 9.85437C19.7081 15.3122 15.3117 19.7087 9.85406 19.7087ZM9.85406 1.51606C5.23023 1.51606 1.51601 5.2304 1.51601 9.85437C1.51601 14.4783 5.23023 18.1927 9.85406 18.1927C14.4779 18.1927 18.1921 14.4783 18.1921 9.85437C18.1921 5.2304 14.4779 1.51606 9.85406 1.51606Z"
              fill="black"
              fill-opacity="0.5"
            />
            <path
              d="M17.1932 16.1211L24 22.9282L22.9282 24L16.1213 17.1929L17.1932 16.1211Z"
              fill="black"
              fill-opacity="0.5"
            />
          </svg>
        </span>
      </div>
      <div class="body__tools">
        <div class="filter">
          <p>Filter by Categories</p>
          <div class="filters">
            <div
              class="filter_"
              v-for="(tag, i) in tags"
              :key="i"
              @click="toogleFilter(tag)"
              :class="{ active: activeTags.indexOf(tag) >= 0 }"
            >
              {{ tag }}
            </div>
          </div>
        </div>
        <div class="tool__wraper">
          <div
            class="tool"
            v-for="(guide, n) in filteredGuides"
            :key="n"
            :class="{
              active: activeGuides.includes(
                guide.profile.profileName.toLowerCase()
              )
            }"
          >
            <div class="tool-event" @click="toogleGuide(guide)">
              <div>
                <div class="left">
                  <img
                    class="tool-image"
                    :src="guide.user.imgURL"
                    :alt="guide.user.firstname"
                  />
                  <h4>
                    {{ guide.user.firstname + " " + guide.user.lastname }}
                  </h4>
                </div>

                <div class="ico check">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                    <path
                      d="M4 13.875L8.09091 18L19 7"
                      stroke="var(--theme-color)"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </div>
              </div>
              <p v-if="guide.profile.bio && guide.profile.bio.length > 100">
                {{ guide.profile.bio.substring(0, 100) }}...
              </p>
              <p v-else>{{ guide.profile.bio }}</p>
            </div>
            <div
              class="ico video"
              v-b-tooltip.hover
              title="Add Guide"
              @click="addGuideInstant(guide)"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="12"
                  fill="var(--theme-color)"
                  fill-opacity="0.1"
                />
                <path
                  d="M12.0002 5.14282V18.8571"
                  stroke="var(--theme-color)"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M5.14282 12.0002L18.8571 12.0002"
                  stroke="var(--theme-color)"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="show == 'display'">
      <div class="header__tools border-none">
        <span class="ico" @click="show = 'guides'">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#E4E6EB" />
            <path
              d="M28 18H8M8 18L16 10M8 18L16 26"
              stroke="#606770"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <!-- <h3>Tools</h3> -->
      </div>
      <div class="body__tools">
        <div class="description__wraper">
          <img
            :src="activeDisplayGuide.user.imgURL"
            :alt="activeDisplayGuide.user.firstname"
          />
          <h3>
            {{
              activeDisplayGuide.user.firstname +
                " " +
                activeDisplayGuide.user.lastname
            }}
          </h3>
          <div>
            <p>
              {{ activeDisplayGuide.profile.bio }}
            </p>
          </div>
          <!-- <div v-html="activeDisplayGuide.desc"></div> -->
          <button class="btn-add-crew" @click="handleAddThis">
            + ADD THIS
          </button>
        </div>
      </div>
    </template>
    <template v-if="show == 'search'">
      <div class="header__tools header__search">
        <input
          type="search"
          class="search"
          v-model="searchStr"
          placeholder="Search"
        />
        <span class="ico" @click="hideSearch">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M16.7855 16.0008L22.9482 9.83807C23.1652 9.6211 23.1652 9.26932 22.9482 9.05238C22.7312 8.83543 22.3794 8.83541 22.1625 9.05238L15.9998 15.2151L9.83709 9.05238C9.62012 8.83541 9.26834 8.83541 9.0514 9.05238C8.83446 9.26935 8.83443 9.62113 9.0514 9.83807L15.2141 16.0008L9.0514 22.1635C8.83443 22.3804 8.83443 22.7322 9.0514 22.9492C9.15987 23.0576 9.30207 23.1119 9.44426 23.1119C9.58646 23.1119 9.72862 23.0576 9.83712 22.9492L15.9998 16.7865L22.1625 22.9492C22.2709 23.0576 22.4131 23.1119 22.5553 23.1119C22.6975 23.1119 22.8397 23.0576 22.9482 22.9492C23.1652 22.7322 23.1652 22.3804 22.9482 22.1635L16.7855 16.0008Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="14.2222"
                  height="14.2222"
                  fill="white"
                  transform="translate(8.88867 8.88892)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
      </div>
      <div class="body__tools">
        <div class="tool__wraper">
          <div
            class="tool"
            v-for="(guide, n) in searchedGuides"
            :key="n"
            @click="toogleGuide(guide)"
            :class="{
              active: activeGuides.includes(
                guide.profile.profileName.toLowerCase()
              )
            }"
          >
            <div>
              <div class="left">
                <img :src="guide.user.imgURL" alt="guide-image" width="50" />
                <h4>{{ guide.user.firstname + " " + guide.user.lastname }}</h4>
              </div>
              <div class="ico video">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="12"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M12.0002 5.14282V18.8571"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.14282 12.0002L18.8571 12.0002"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <div class="ico check">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                  <path
                    d="M4 13.875L8.09091 18L19 7"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
            </div>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      guides: [],
      tags: ["Spiritual", "Health", "Education", "Finance"],
      activeTags: [],
      show: "guides", //tools, display, search
      activeGuides: [],
      searchStr: "",
      activeDisplayGuide: {},
      allGuides: []
    };
  },
  mounted() {
    this.$store.dispatch("listings/getListGuides").then(guides => {
      this.allGuides = guides;
      console.log(guides);
    });
  },
  watch: {
    show(newv, oldv) {
      if (newv == "search") {
        setTimeout(() => {
          document.querySelector(".search").focus();
        }, 100);
      }
    }
  },
  computed: {
    searchedGuides() {
      if (this.searchStr.trim() == "") return this.allGuides;

      return this.allGuides.filter(guide => {
        return (
          guide.user.firstname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim()) ||
          guide.user.lastname
            .toLowerCase()
            .includes(this.searchStr.toLowerCase().trim())
        );
      });
    },
    filteredGuides() {
      if (this.activeTags.length == 0) return this.allGuides;
      let guidesToDisplay = [];
      this.allGuides.forEach(guide => {
        if (guide.profile && guide.profile.tags) {
          guide.profile.tags.forEach(tag => {
            this.activeTags.forEach(activeTag => {
              if (tag.text.toLowerCase() == activeTag.toLowerCase()) {
                guidesToDisplay.push(guide);
              }
            });
          });
        }
      });
      return guidesToDisplay;
    }
  },
  methods: {
    addGuideInstant(aGuide) {
      if (this.activeGuides.length < 4) {
        let guide = {
          _created_at: new Date(),
          name: aGuide.user.firstname + " " + aGuide.user.lastname,
          profileName: aGuide.profile.profileName,
          imgURL: aGuide.user.imgURL
        };
        this.guides.push(guide);
        this.activeGuides.push(aGuide.profile.profileName.toLowerCase());
      }
    },
    hideSearch() {
      this.searchStr = "";
      this.show = "guides";
    },
    toogleFilter(tag) {
      let index = this.activeTags.indexOf(tag);
      if (index >= 0) {
        this.activeTags.splice(index, 1);
      } else {
        this.activeTags.push(tag);
      }
    },
    toogleGuide(guide) {
      this.searchStr = "";
      let guideIndex = this.activeGuides.indexOf(
        guide.profile.profileName.toLowerCase()
      );
      if (guideIndex >= 0) {
        this.activeGuides.splice(guideIndex, 1);
        this.guides.splice(guideIndex, 1);
      } else {
        this.activeDisplayGuide = guide;
        this.show = "display";
      }
    },
    handleAddThis() {
      if (this.activeGuides.length < 4) {
        this.activeGuides.push(
          this.activeDisplayGuide.profile.profileName.toLowerCase()
        );
        this.show = "guides";
        let guide = {
          _created_at: new Date(),
          name:
            this.activeDisplayGuide.user.firstname +
            " " +
            this.activeDisplayGuide.user.lastname,
          profileName: this.activeDisplayGuide.profile.profileName,
          imgURL: this.activeDisplayGuide.user.imgURL
        };
        this.guides.push(guide);
      }
    },
    updateGuides() {
      this.$emit("updateGuides", this.guides);
    }
  }
};
</script>

<style lang="scss" scoped>
.tools {
  .header__tools {
    position: relative;
    padding-bottom: 8px;
    &.border-none::after {
      content: none !important;
    }
    .ico {
      position: absolute;
      top: 5px;
      left: 13px;
      cursor: pointer;
    }
    .ico__search {
      left: unset !important;
      right: 13px;
    }
    h3 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;

      color: #5b606c;
    }
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      border-bottom: 1px solid #e4e6eb;
    }
  }
  .body__tools {
    height: 100%;
    .filter {
      display: flex;
      align-items: center;
      margin-top: 20px;
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #5b606c;
        width: 160px;
        margin: 0;
      }
      .filters {
        height: 45px;
        display: flex;
        align-items: center;
        max-width: 100%;
        overflow-x: scroll;
        &::-webkit-scrollbar {
          height: 0px;
          margin-right: 10px;
        }

        &::-webkit-scrollbar-track {
          background-color: #fff;
        }

        &::-webkit-scrollbar-thumb {
          background: #dddddd;
          // border-radius: 16px;
        }
        .filter_ {
          cursor: pointer;
          padding: 8px 16px;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          background-color: #fff;
          color: #5b606c;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
          border-radius: 32px;
          margin-right: 16px;
          &.active {
            background: rgba(85, 126, 251, 0.1);
            color: var(--theme-color);
            box-shadow: none;
          }
        }
      }
    }
    .tool__wraper {
      padding: 32px 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 24px 12px;
      max-height: 530px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 5px;
        margin-right: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      &::-webkit-scrollbar-thumb {
        background: #dddddd;
        border-radius: 16px;
      }
    }
    .tool {
      cursor: pointer;
      position: relative;
      border-radius: 5px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      .tool-event {
        padding: 18px;
        & > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }
      .video {
        position: absolute;
        top: 22px;
        right: 18px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #474d52;
        margin-top: 10px;
        margin-bottom: 0;
      }
      h4 {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
        margin-bottom: 0;
        margin-left: 10px;
      }
      .left {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .check {
        display: none;
      }
      &.active {
        .check {
          display: block !important;
        }
        .video {
          display: none !important;
        }
        background-color: #e8eaf9;
      }
    }
    .description__wraper {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: column;
      img {
        margin-bottom: 34px;
        height: 48px;
        width: 48px;
      }
      h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
        color: #5b606c;
        margin-bottom: 34px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;

        color: #5b606c;
      }
      .btn-add-crew {
        margin-top: 80px;
        margin-bottom: 30px;
      }
    }
  }
}
.header__search {
  display: flex;
  align-items: center;
  input {
    border: none;
    padding: 5px 10px;
    width: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    //   text-align: center;
    color: #5b606c;
  }
  .ico {
    left: unset !important;
    right: 13px;
  }
}
.tool-image {
  width: 50px;
}
@media (max-width: 520px) {
  .body__tools {
    grid-template-columns: 1fr !important;
  }
}
</style>
<style>
#blog-guides___BV_modal_content_,
#crew-modal___BV_modal_content_ {
  height: 700px;
}
</style>
